import { Button } from "components/ui"
import { BaseModal } from "components/shared"
import React, { Suspense } from "react"
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from 'react-i18next'
import { toggleChangeOperator } from "../store/stateSlice";
import ChangeOperatorContent from "./ChangeOperatorContent";


const CONTENT_STYLE = {
    overflowY: 'hidden',
    overflowX: 'hidden',
    paddingTop: 0,
    paddingRight: '1.5rem',
    paddingBottom: '1rem',
    paddingLeft: '1.5rem',
}

const ChangeOperatorDialog = () => {
    const { t } = useTranslation()

    const dispatch = useDispatch()

    const { changeOperatorView } = useSelector(state => state.ticketList.state)

    const onDialogClose = () => {
        dispatch(toggleChangeOperator(false))
    }

    return (
        <BaseModal
            isOpen={changeOperatorView}
            onClose={onDialogClose}
            onRequestClose={onDialogClose}
            title={t('ticket_change_operator')}
            width={500}
            contentClassName="flex flex-col"
            contentStyle={CONTENT_STYLE}
            footer={
                <Button block variant="solid" onClick={onDialogClose}>
                    {t('close')}
                </Button>
            }
        >

            <Suspense fallback={<></>}>
                <ChangeOperatorContent/>
            </Suspense>
        </BaseModal>
    )
}

export default ChangeOperatorDialog
